import React from "react";
import {
  IDateTimeFormatterProps,
  dateTimeFormatter,
  dateFormatter,
  timeFormatter
} from "/imports/utils/functions/fnDateTimeFormatter";


export const DateTimeTag = ({ date, options }: IDateTimeFormatterProps) => {
  return <>{dateTimeFormatter({ date, options })}</>
};

export const DateTag = ({ date, options }: IDateTimeFormatterProps) => {
  return (<>{dateFormatter({ date, options })}</>);
};

export const TimeTag = ({ date, options }: IDateTimeFormatterProps) => {
  return (<>{timeFormatter({ date, options })}</>);
};

export default DateTimeTag;
